/**
 * EM 路由解析助手，mixin
 *   提供从路径中解析出实体名 模块名 路径名 的功能
 *
 * em模块路由规范:
 *
 *   使用通用模板页面：/em/modelName/entityName/viewType?pathType
 *   使用自己的vue页面：/em/modelName/entityNameViewType?pathType
 *
 *     modelName：模块名
 *     entityName：实体类名
 *     viewType：vue中不同的路由，例如list/edit/task
 *     pathType：可以针对vue中同一路由，传入不同pathType，例如针对edit路由可以有new/edit，针对list路由可以有todo/wait/list等
 *
 * Author YuJiaBei
 * Date 2020-07-12 08:14:36
 */
export default {
    computed: {
        /**
         * @returns {string}
         * 页面路由类型，配合emMenu中的定义，从query参数pathType中取得
         */
        $_emRouterHelperMixin_pathType() {
            return this.$route.query.pathType
        },
        /**
         * @returns {string}
         * 当前路由，如 "/master/teamShift/edit"
         */
        $_emRouterHelperMixin_path() {
            return this.$route.path;
        },
        /**
         * @returns {list}
         * 当前路由路径项
         */
        $_emRouterHelperMixin_pathItems() {
            return this.$_emRouterHelperMixin_path.split('/');
        },
        /**
         * @returns {string}
         * 判断当前页面类型
         */
        $_emRouterHelperMixin_pageMode() {
            let items = this.$_emRouterHelperMixin_pathItems;
            let lastWord = items.slice(-1)[0];
            if (lastWord === 'edit') {
                return 'edit'
            } else if (lastWord === 'list') {
                return 'list'
            } else if (lastWord === 'task') {
                return 'task'
            } else if (lastWord.endsWith('Edit')) {
                return 'Edit'
            } else if (lastWord.endsWith('List')) {
                return 'List'
            } else if (lastWord.endsWith('Task')) {
                return 'Task'
            }
        },
        /**
         * @returns {number}
         * 判断实体名在路径中的位置
         * 如 路径为 'master/teamShift'
         * 实体名是 teamShift, 故返回 -1
         */
        $_emRouterHelperMixin_entityNameIndex() {
            let newModel = ['edit', 'list', 'task']
            let mode = this.$_emRouterHelperMixin_pageMode;
            let len = this.$_emRouterHelperMixin_pathItems.length;
            if (newModel.includes(mode)) {
                return len - 2;
            } else {
                return len - 1;
            }
        },
        /**
         * @returns {string}
         * 返回当前实体名称，如 teamShift, carPlan, shipPlan 等
         */
        $_emRouterHelperMixin_entityName() {
            let oldModel = ['Edit', 'List', 'Task']
            let mode = this.$_emRouterHelperMixin_pageMode;
            let index = this.$_emRouterHelperMixin_entityNameIndex;
            let items = this.$_emRouterHelperMixin_pathItems;
            let entityName = oldModel.includes(mode) ? items.slice(index)[0].slice(0, -mode.length) : items.slice(index)[0];
            return entityName
        },
        /**
         * @returns {string}
         * 返回路由中实体名前面的路径（去除结尾斜杠）
         * 如 _path = "/master/teamShift"
         * 返回 "/master"
         */
        $_emRouterHelperMixin_backPath() {
            let index = this.$_emRouterHelperMixin_entityNameIndex;
            let items = this.$_emRouterHelperMixin_pathItems;
            return items.slice(0, index).join("/");
        },
        /**
         * @returns {string}
         * 返回store中定义的后端接口路径：baseModuleUrl
         */
        $_emRouterHelperMixin_baseBackendUrl() {
            let entityName = this.$_emRouterHelperMixin_entityName
            let baseModuleUrl = this.$store.state[entityName].baseModuleUrl
            return baseModuleUrl
        }
    }
}
